import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import routes from '@Constants/Routes'
import { Button as AbwButton } from '@Components/AbwaabPlus'
import { trackEvent } from '@Utilities/marketingTags'

/** 404 screen — centred brand-blue numeral + Arabic copy + a working home CTA. */
const NotFoundPage = () => {
	const [t] = useTranslation('generic')
	const navigate = useNavigate()

	// On the component, not the route: this renders for unmatched paths AND via
	// the RequirePlatform gate at a 200 URL, so a URL-based GTM rule misses it.
	useEffect(() => {
		trackEvent('ErrorPage', {
			error_code: 404,
			page_url: window.location.href,
			referrer: document.referrer || null,
		})
	}, [])

	return (
		<Wrap>
			<Numeral dir="ltr">404</Numeral>
			<span className="emoji" role="img" aria-hidden>
				🔍
			</span>
			<Title>{t('not_found_title')}</Title>
			<Sub>{t('not_found_sub')}</Sub>
			<AbwButton variant="primary" onClick={() => navigate(routes.home)}>
				{t('back_home')}
			</AbwButton>
		</Wrap>
	)
}

export default NotFoundPage

const Wrap = styled.div`
	flex: 1;
	min-height: 60vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: var(--space-4);
	padding: var(--space-12) var(--space-6);
	.emoji {
		font-size: 30px;
		line-height: 1;
	}
`
const Numeral = styled.div`
	font: var(--fw-bold) 72px/1 var(--font-sans);
	color: var(--blue);
`
const Title = styled.div`
	font: var(--fw-bold) var(--fs-body-lg) var(--font-sans);
	color: var(--text-primary);
	text-align: center;
`
const Sub = styled.div`
	font: var(--fw-regular) 13px var(--font-sans);
	color: var(--text-secondary);
	text-align: center;
`
